var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3025_7839)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8086 12.5C24.8086 19.1274 19.436 24.5 12.8086 24.5C6.18118 24.5 0.808594 19.1274 0.808594 12.5C0.808594 5.87258 6.18118 0.5 12.8086 0.5C19.436 0.5 24.8086 5.87258 24.8086 12.5ZM13.2386 9.35893C12.0714 9.8444 9.73873 10.8492 6.24049 12.3733C5.67243 12.5992 5.37485 12.8202 5.34776 13.0363C5.30198 13.4015 5.7593 13.5453 6.38206 13.7411C6.46677 13.7678 6.55455 13.7954 6.64453 13.8246C7.25723 14.0238 8.08142 14.2568 8.50988 14.266C8.89854 14.2744 9.33232 14.1142 9.81123 13.7853C13.0798 11.579 14.767 10.4638 14.8729 10.4398C14.9476 10.4228 15.0512 10.4015 15.1214 10.4638C15.1915 10.5262 15.1846 10.6443 15.1772 10.676C15.1319 10.8691 13.3367 12.5381 12.4077 13.4018C12.1181 13.671 11.9127 13.862 11.8707 13.9056C11.7766 14.0033 11.6807 14.0958 11.5886 14.1846C11.0194 14.7333 10.5925 15.1448 11.6122 15.8168C12.1022 16.1397 12.4944 16.4067 12.8856 16.6731C13.3128 16.9641 13.7389 17.2543 14.2902 17.6157C14.4307 17.7077 14.5648 17.8034 14.6955 17.8965C15.1927 18.251 15.6393 18.5694 16.1912 18.5186C16.5118 18.4891 16.8431 18.1876 17.0113 17.2884C17.4088 15.1631 18.1902 10.5585 18.3708 8.66097C18.3866 8.49473 18.3667 8.28197 18.3507 8.18857C18.3348 8.09518 18.3014 7.96211 18.18 7.8636C18.0362 7.74694 17.8142 7.72234 17.715 7.72408C17.2636 7.73203 16.5711 7.97282 13.2386 9.35893Z",
    fill: "#403B37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3025_7839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.808594 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.4b93fc79eabc0841345c02cabd9e218a.svg";
export { ForwardRef as ReactComponent };